import type { StudioSettingSlot } from './StudioFormParts';

export interface Cell extends StudioSettingSlot {
  more?: string[];
  rest?: StudioSettingSlot[];
}
/** Правило B1 (V157): ячеек не больше шести */
export const SC_MAX = 6;
/** Ячейки по правилу B1: свои ячейки экрана стоят всегда, ячейки блока сворачиваются в последнюю «+N». */
export function studioSettingCells(slots: StudioSettingSlot[]): Cell[] {
  const groups = [...new Set(slots.filter(slot => slot.group).map(slot => slot.group!))];
  const own = slots.filter(slot => !slot.group).length;
  const free = groups.length ? Math.max(1, Math.floor((SC_MAX - own) / groups.length)) : 0;
  const out: Cell[] = [];
  const seen = new Set<string>();
  for (const slot of slots) {
    if (!slot.group) {
      out.push(slot);
      continue;
    }
    if (seen.has(slot.group)) continue;
    seen.add(slot.group);
    const block = slots.filter(item => item.group === slot.group);
    if (block.length <= free) {
      out.push(...block);
      continue;
    }
    const shown = block.slice(0, free - 1),
      rest = block.slice(free - 1);
    out.push(...shown, {
      title: '',
      value: rest.map((item, index) => (index ? item.title.toLocaleLowerCase() : item.title)).join(', '),
      group: slot.group,
      section: rest[0].section,
      drill: undefined,
      more: rest.map(item => item.title),
      rest,
    });
  }
  return out;
}
